import config from '@/config';

// eslint-disable-next-line import/prefer-default-export
export const HUBSPOT_TRACKING_CODE = config.hubSpotTrackingCode;
